/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) { window.boostSDAppConfig.integration = Object.assign({ wishlists: 'king' }, window.boostSDAppConfig.integration || {}); }

if(boostSDAppConfig?.filterSettings) {   boostSDAppConfig.filterSettings.filterLayout = 'horizontal'; }